<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const user = computed(() => store.getters['users/user']);
</script>

<template>
  <section class="mb-4 flex items-center justify-center text-3xl font-medium text-brand-600">
    <h1>
      Welcome <b>{{ user.username }}</b>
    </h1>
  </section>
</template>
